import { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { initFlowbite } from 'flowbite'
import { authService } from 'services/auth.services'

import { _object } from 'utils/interfaces'

import ProfileEdit from 'components/profile-edit'
import SetPassword from 'components/modal/set-password'

import { Placeholder } from 'assets/images'
import { EditIcon, ModalCloseIcon } from 'assets/svg'
import { destroyAuthSession } from '../redux/slices/session.slice'

const UserProfile = () => {
  const { loggedInUser } = useSelector((state: _object) => state.session)
  const dispatch = useDispatch()

  useEffect(() => {
    initFlowbite()
  }, [])

  const deleteAccount = () => {
    authService.deleteAccount().then((res: _object) => {
      if (res?.error === false) {
        window.location.href = '/login'
      }
    })
  }
  return (
    <>
      <section className="p-6">
        <div className="account-banner mb-4 flex h-[180px] items-center justify-center rounded-2xl bg-blue-100 p-8 md:h-[205px] 2xl:h-[200px]">
          <h3 className="text-lg font-semibold">My Account</h3>
        </div>

        <div className="mx-auto block w-fit justify-center rounded-2xl shadow-lg md:flex md:w-[44rem]">
          <div className="account-general h-[20rem] w-full bg-center md:h-auto md:w-3/6 md:rounded-s-2xl">
            <img className="h-full w-full rounded-s-lg" src={Placeholder} alt="Profile" />
          </div>

          <div className="w-full rounded-e-2xl bg-white p-8 md:w-3/6">
            <div className="relative mx-auto mb-7 h-24 w-24 shrink-0">
              <img
                className="h-full w-full rounded-full border-2 border-gray-300 object-cover"
                src={Placeholder}
                alt="Profile"
              />
              <button
                data-modal-target="profile-edit-modal"
                data-modal-toggle="profile-edit-modal"
                className="absolute right-1 -bottom-2 flex h-9 w-9 items-center justify-center rounded-full border-2 border-white bg-gray-200 p-0.5"
              >
                <EditIcon className="h-4 w-4" />
              </button>
            </div>

            <div className="space-y-5 divide-y divide-gray-300 text-center">
              <div>
                <h2 className="mt-4 text-xl font-semibold">{loggedInUser?.full_name}</h2>
                <p className="my-1 text-sm text-gray-700">{loggedInUser?.email}</p>
                <p className="text-sm font-medium text-gray-900">ID: {loggedInUser?.id_number}</p>
              </div>

              <div className="pt-5">
                <button
                  data-modal-target="default-modal"
                  data-modal-toggle="default-modal"
                  className="block rounded-lg bg-blue-700 px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 focus:outline-none dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  type="button"
                >
                  Change Password
                </button>
              </div>

              <div className="pt-5">
                <button
                  onClick={() => {
                    if (window.confirm('Do you wish to sign out?')) {
                      dispatch(destroyAuthSession())
                    }
                  }}
                  className="font-semibold text-black"
                >
                  LogOut
                </button>
              </div>

              <div className="pt-5">
                <button
                  className="font-semibold text-red-600 underline underline-offset-4"
                  onClick={() => {
                    if (window.confirm('Do you wish to delete account?')) {
                      deleteAccount()
                    }
                  }}
                >
                  Delete Account
                </button>
              </div>
            </div>
          </div>
        </div>

        <div id="profile-edit-modal" aria-hidden="true" className="modal hidden backdrop-blur-sm">
          <ProfileEdit />
        </div>

        <div id="set-password-modal" aria-hidden="true" className="modal hidden backdrop-blur-sm">
          <div className="modal-dialog modal-dialog-centered w-full bg-cover bg-center md:w-[30rem]">
            <div className="modal-content p-8 md:mx-0 md:p-12">
              <button className="absolute top-5 right-5" data-modal-hide="set-password-modal">
                <ModalCloseIcon className="h-6 w-6" />
              </button>

              <h4>Change Password</h4>
              <SetPassword />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default UserProfile
